import { observer } from 'mobx-react';
import React, { useEffect, useState } from 'react';
import Paper from '@mui/material/Paper';
import { Grid, Stack, Typography, createTheme, CardActionArea, useMediaQuery } from '@mui/material';
import Card from '@mui/material/Card';
import CardMedia from '@mui/material/CardMedia';
import './style.css';
import { datetimeFormatter } from '../../utils/datetimeFormatter';
import dayjs from 'dayjs';
import { isEmpty } from '../../utils/helper';
import elevation1 from '../../assets/images/elevation-style/1.jpeg';
import elevation2 from '../../assets/images/elevation-style/2.jpeg';
import elevation3 from '../../assets/images/elevation-style/3.jpeg';
import elevation4 from '../../assets/images/elevation-style/4.jpeg';

export const ReadOnlyConstructionSpecification = observer(({ details }) => {
  const theme = createTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  const getData = (value) => {
    return isEmpty(value) ? '_' : value;
  };

  const images = [elevation1, elevation2, elevation3, elevation4];

  return (
    <Paper sx={{ px: '30px', py: '20px', pb: '40px' }}>
      <Stack spacing={4}>
        <Stack spacing={3}>
          <Grid rowGap={2} container justifyContent={'space-evenly'}>
            <Grid item xs={12} sm={6} md={6} lg={6}>
              <Stack direction={'row'} width={'100%'} height={'100%'} spacing={4}>
                <Stack direction={'column'} spacing={2} sx={{ color: '#626A72', fontWeight: '500' }}>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: '700',
                      alignSelf: 'end',
                    }}
                    component="p"
                  >
                    Masonry
                  </Typography>
                  {details?.masonry === 'Other' && (
                    <Typography
                      sx={{
                        fontSize: '12px',
                        fontWeight: '700',
                        alignSelf: 'end',
                      }}
                      component="p"
                    >
                      Masonry Other
                    </Typography>
                  )}
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: '700',
                      alignSelf: 'end',
                    }}
                    component="p"
                  >
                    Rain Water Harvesting
                  </Typography>
                </Stack>
                <Stack direction={'column'} spacing={2}>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: '700',
                      alignSelf: 'start',
                    }}
                    component="p"
                  >
                    {getData(details?.masonry)}
                  </Typography>
                  {details?.masonry === 'Other' && (
                    <Typography
                      sx={{
                        fontSize: '12px',
                        fontWeight: '700',
                        alignSelf: 'start',
                      }}
                      component="p"
                    >
                      {getData(details?.masonryOther)}
                    </Typography>
                  )}
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: '700',
                      alignSelf: 'start',
                    }}
                    component="p"
                  >
                    {getData(details?.rainWaterHarvesting?.toString())}
                  </Typography>
                </Stack>
              </Stack>
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={6}>
              <Stack direction={'row'} width={'100%'} height={'100%'} spacing={4}>
                <Stack direction={'column'} spacing={2} sx={{ color: '#626A72', fontWeight: '500' }}>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: '700',
                      alignSelf: 'end',
                    }}
                    component="p"
                  >
                    Windows
                  </Typography>
                </Stack>
                <Stack direction={'column'} spacing={2}>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: '700',
                      alignSelf: 'start',
                    }}
                    component="p"
                  >
                    {getData(details?.windows)}
                  </Typography>
                </Stack>
              </Stack>
            </Grid>
          </Grid>
        </Stack>
        {details.elevationStyle && (
          <Stack spacing={3}>
            <Stack direction={'column'} spacing={2} sx={{ color: '#626A72', fontWeight: '500' }}>
              <Typography sx={{ fontSize: '12px', fontWeight: '700', alignSelf: 'start' }} component="p">
                Elevation Style
              </Typography>
            </Stack>
            <Stack flexDirection={'row'} rowGap={3} columngap={4} flexWrap={'wrap'}>
              <Card sx={{ maxWidth: 100 }}>
                <CardActionArea>
                  <CardMedia
                    component="img"
                    image={images[parseInt(details.elevationStyle)]}
                    alt="green iguana"
                    onClick={() => window.open(images[parseInt(details.elevationStyle)], '_blank')}
                  />
                </CardActionArea>
              </Card>
            </Stack>
          </Stack>
        )}
      </Stack>
    </Paper>
  );
});
